import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEmptyState } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { formatMoneyCompact } from '../../../../lib/format/money';
import { documentsSectionFromResponse } from '../../documents/recordDocumentsSection';
import { HoldingBadge, monthYear, VehicleRefLink } from './vehicleUi';
export function vehicleRail(d, holders, onLineage, docs, docsState) {
    const successor = d.successors.find((edge)=>edge.relation === 'SUCCESSOR' && !edge.archivedAt);
    return [
        {
            id: 'vehicle-facts',
            title: 'Facts',
            facts: [
                ...d.awardingOrg ? [
                    {
                        id: 'awarded',
                        label: 'Awarded by',
                        value: /*#__PURE__*/ _jsx(VehicleRefLink, {
                            value: d.awardingOrg
                        })
                    }
                ] : [],
                ...d.orderingEligibility ? [
                    {
                        id: 'eligibility',
                        label: 'Who can order',
                        value: d.orderingEligibility
                    }
                ] : [],
                ...d.maxCeilingValue > 0 ? [
                    {
                        id: 'ceiling',
                        label: 'Program ceiling',
                        value: formatMoneyCompact(d.maxCeilingValue * 100)
                    }
                ] : [],
                ...d.orderingStart || d.orderingEnd ? [
                    {
                        id: 'ordering',
                        label: 'Ordering',
                        value: d.orderingStart && d.orderingEnd ? `${monthYear(d.orderingStart)} – ${monthYear(d.orderingEnd)}` : d.orderingStart ? `from ${monthYear(d.orderingStart)}` : `until ${monthYear(d.orderingEnd)}`
                    }
                ] : []
            ],
            children: d.factsSourceNote ? /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                tone: "muted",
                children: d.factsSourceNote
            }) : undefined
        },
        {
            id: 'vehicle-successor',
            title: successor?.successor ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "Successor · ",
                    /*#__PURE__*/ _jsx(VehicleRefLink, {
                        value: successor.successor
                    })
                ]
            }) : 'Successor',
            action: onLineage && /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "ghost",
                size: "xs",
                "data-testid": Testids.registryVehicle.recordSuccessor,
                onClick: onLineage,
                children: successor ? 'Manage lineage' : 'Record successor'
            }),
            facts: successor?.effectiveDate ? [
                {
                    id: 'ordering',
                    label: 'Ordering',
                    value: `from ${successor.effectiveDate.toDate().getUTCFullYear()}`
                }
            ] : [],
            rows: holders?.compareVehicle?.id === successor?.successor?.id ? holders?.rows.filter((r)=>r.companyIsOwn || r.isTeammate || r.holdingCompare).map((r)=>({
                    id: r.company?.id ?? '',
                    label: r.companyIsOwn ? 'Us' : /*#__PURE__*/ _jsx(VehicleRefLink, {
                        value: r.company
                    }),
                    value: /*#__PURE__*/ _jsx(HoldingBadge, {
                        status: r.holdingCompare,
                        compare: true
                    })
                })) : [],
            children: !successor && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                tone: "muted",
                children: "No successor recorded."
            })
        },
        {
            id: 'vehicle-notices',
            title: 'Open notices on this vehicle',
            children: /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: "Notices are not linked to vehicles yet."
            })
        },
        documentsSectionFromResponse({
            kind: 'VEHICLE',
            id: d.vehicleId
        }, docs, docsState)
    ];
}
